import { Language } from "~/shared/enums";

export const LANGUAGE_SET = new Set(Object.values(Language));

// spell-checker:disable
export const LANGUAGE_TO_DISPLAY_NAME: Record<Language, string> = {
  [Language.ALBANIAN]: "Shqip",
  [Language.AMHARIC]: "አማርኛ",
  [Language.ARABIC]: "العربية",
  [Language.ARMENIAN]: "Հայերեն",
  [Language.AWADHI]: "अवधी",
  [Language.AZERBAIJANI]: "Azərbaycanca",
  [Language.BASHKIR]: "Башҡортса",
  [Language.BASQUE]: "Euskara",
  [Language.BELARUSIAN]: "Беларуская",
  [Language.BENGALI]: "বাংলা",
  [Language.BHOJPURI]: "भोजपुरी",
  [Language.BOSNIAN]: "Bosanski",
  [Language.BRAZILIAN_PORTUGUESE]: "Português (Brasil)",
  [Language.BULGARIAN]: "Български",
  [Language.BURMESE]: "ဗမာ",
  [Language.CANTONESE_YUE]: "粵語",
  [Language.CATALAN]: "Català",
  [Language.CHHATTISGARHI]: "छत्तीसगढ़ी",
  [Language.CROATIAN]: "Hrvatski",
  [Language.CZECH]: "Čeština",
  [Language.DANISH]: "Dansk",
  [Language.DOGRI]: "डोगरी",
  [Language.DUTCH]: "Nederlands",
  [Language.ENGLISH]: "English",
  [Language.ESTONIAN]: "Eesti",
  [Language.FAROESE]: "Føroyskt",
  [Language.FINNISH]: "Suomi",
  [Language.FRENCH]: "Français",
  [Language.GALICIAN]: "Galego",
  [Language.GEORGIAN]: "ქართული",
  [Language.GERMAN]: "Deutsch",
  [Language.GREEK]: "Ελληνικά",
  [Language.GUJARATI]: "ગુજરાતી",
  [Language.HARYANVI]: "हरियाणवी",
  [Language.HEBREW]: "עברית",
  [Language.HINDI]: "हिंदी",
  [Language.HUNGARIAN]: "Magyar",
  [Language.ICELANDIC]: "Íslenska",
  [Language.INDONESIAN]: "Bahasa Indonesia",
  [Language.IRISH]: "Gaeilge",
  [Language.ITALIAN]: "Italiano",
  [Language.JAPANESE]: "日本語",
  [Language.JAVANESE]: "Basa Jawa",
  [Language.KANNADA]: "ಕನ್ನಡ",
  [Language.KASHMIRI]: "کشمیری",
  [Language.KAZAKH]: "Қазақша",
  [Language.KONKANI]: "कोंकणी",
  [Language.KOREAN]: "한국어",
  [Language.KYRGYZ]: "Кыргызча",
  [Language.LATVIAN]: "Latviešu",
  [Language.LITHUANIAN]: "Lietuvių",
  [Language.MACEDONIAN]: "Македонски",
  [Language.MAITHILI]: "मैथिली",
  [Language.MALAY]: "Bahasa Melayu",
  [Language.MALAYALAM]: "മലയാളം",
  [Language.MALTESE]: "Malti",
  [Language.MANDARIN_CHINESE]: "普通话",
  [Language.MARATHI]: "मराठी",
  [Language.MARWARI]: "मारवाड़ी",
  [Language.MIN_NAN]: "閩南語",
  [Language.MOLDOVAN]: "Moldovenesc",
  [Language.MONGOLIAN]: "Монгол",
  [Language.MONTENEGRIN]: "Црногорски",
  [Language.NEPALI]: "नेपाली",
  [Language.NORWEGIAN]: "Norsk",
  [Language.ORIYA]: "ଓଡ଼ିଆ",
  [Language.PASHTO]: "پښتو",
  [Language.PERSIAN_FARSI]: "فارسی",
  [Language.POLISH]: "Polski",
  [Language.PORTUGUESE]: "Português",
  [Language.PUNJABI]: "ਪੰਜਾਬੀ",
  [Language.RAJASTHANI]: "राजस्थानी",
  [Language.ROMANIAN]: "Română",
  [Language.RUSSIAN]: "Русский",
  [Language.SANSKRIT]: "संस्कृतम्",
  [Language.SANTALI]: "ᱥᱟᱱᱛᱟᱲᱤ",
  [Language.SERBIAN]: "Српски",
  [Language.SINDHI]: "سندھی",
  [Language.SINHALA]: "සිංහල",
  [Language.SLOVAK]: "Slovenčina",
  [Language.SLOVENIAN]: "Slovenščina",
  [Language.SOMALI]: "Soomaali",
  [Language.SPANISH]: "Español",
  [Language.SWAHILI]: "Kiswahili",
  [Language.SWEDISH]: "Svenska",
  [Language.TAGALOG]: "Tagalog",
  [Language.TAJIK]: "Тоҷикӣ",
  [Language.TAMIL]: "தமிழ்",
  [Language.TATAR]: "Татарча",
  [Language.TELUGU]: "తెలుగు",
  [Language.THAI]: "ไทย",
  [Language.TURKISH]: "Türkçe",
  [Language.TURKMEN]: "Türkmençe",
  [Language.UKRAINIAN]: "Українська",
  [Language.URDU]: "اردو",
  [Language.UZBEK]: "Ўзбекча",
  [Language.VIETNAMESE]: "Tiếng Việt",
  [Language.WELSH]: "Cymraeg",
  [Language.WU]: "吳語",
};
// spell-checker:enable

export const SORTED_LANGUAGES = Object.values(Language).sort((a, b) => a.localeCompare(b));
